import z from 'zod';

export const oaCustomFieldOptionSchema = z.object({
    uuid: z.string().uuid(),
    label: z.string(),
    color: z.string().optional().nullable(),
    position: z.number().optional()
});

export type OACustomFieldOption = z.infer<typeof oaCustomFieldOptionSchema>;
